export default "__VITE_ASSET__DC3u4qcw__"